import React from 'react';
import ReactDOM from 'react-dom';
import FastClick from 'fastclick';
import { deviceIsIOS } from '@configs/constants';
import yoda from '@ks/yoda-js-sdk';
import kuaishouPlugin from '@ks/yoda-kuaishou-plugin';

import { debugConsole } from '@aio/utils';
import App from './App';

try {
  // 提前注册快手插件，否则页面里调不通
  yoda.plugin(kuaishouPlugin);

  /**
   * @param {EventTarget|Element} targetElement
   */
  FastClick.prototype.focus = (targetElement) => {
    let length;
    // Issue #160: on iOS 7, some input elements (e.g. date datetime month) throw a vague TypeError on setSelectionRange. These elements don't have an integer value for the selectionStart and selectionEnd properties, but unfortunately that can't be used for detection because accessing the properties also throws a TypeError. Just check the type instead. Filed as Apple bug #15122724.
    if (
      deviceIsIOS &&
      targetElement.setSelectionRange &&
      targetElement.type.indexOf('date') !== 0 &&
      targetElement.type !== 'time' &&
      targetElement.type !== 'month' &&
      targetElement.type !== 'email'
    ) {
      length = targetElement.value.length;
      targetElement.focus(); // 解决ios 12 input框唤启软键盘不灵敏问题
      targetElement.setSelectionRange(length, length);
    } else {
      targetElement.focus();
    }
  };

  FastClick.attach(document.body);
} catch (e) {
  debugConsole('init error', e);
}

ReactDOM.render(<App />, document.getElementById('root'));
